import { find, get } from 'lodash';

function getReferralScopesFromState(state, groupId) {
  const group = find(get(state, 'groups.data'), { id: groupId }) || {};
  return group.referral_scopes || [];
}

export default getReferralScopesFromState;
